import React from 'react';
import { FontAwesomeIcon } from '../../libs/fonts';

const TicketCard = ({ title, currency, price, text, warningIcon, warningText, buttonText, link }) => (
  <div className='col-lg-6 col-md-6 mb-30'>
    <div className='rs-price-table'>
      <div className='pricing-table-header'>
        <div
          className='table-title'
          dangerouslySetInnerHTML={{ __html: title }}
        />
      </div>
      <div className='rs-pricing-table-price'>
        <div className='pricing-table-price-tag'>
          <span className='table-currency'>{currency}</span>
          <span className='table-price-text'>{price}</span>
          <span className='table-period'></span>
        </div>
      </div>
      <div
        className='rs-pricing-table-body pl-35 pr-35 md-pl-16 md-pr-16'
        dangerouslySetInnerHTML={{ __html: text }}
      />

      {!!warningText && (
        <div className='rs-pricing-table-body'>
          <ul className='pricing-table-features-list'>
            <li style={{ display: 'flex', alignItems: 'center' }}>
              {!!warningIcon && (<FontAwesomeIcon icon={warningIcon} size='2x' />)}
              <span className='feature-text' style={{ flex: 1 }}>{warningText}</span>
            </li>
          </ul>
        </div>
      )}

      {!!(buttonText && link) && (
        <div className='btn-part'>
          <a className='readon btn-text buy-big small orange-btn' href={link}>
            <span>{buttonText}</span>
          </a>
        </div>
      )}
    </div>
  </div>
);

export default TicketCard;
